<template>
	<section class="mb-2">
		<v-row no-gutters>
			<v-col cols="1">
				<v-icon
					small
					color="orange darken-2"
				>
					mdi-map-marker
				</v-icon>
			</v-col>
			<v-col cols="10">
				<v-row no-gutters>
					<v-col cols="12">
						<span>{{ direction.destination.name || direction.destination.formatted_address }}</span>
					</v-col>
				</v-row>
				<v-row
					no-gutters
					class="travelBtn"
				>
					<v-col
						cols="6"
						class="px-1"
					>
						<v-card
							:outlined="isTransitSelected"
							:color="isTransitSelected ? 'grey lighten-2' : undefined"
							class="pa-1 text-right"
							@click="goBy('TRANSIT')"
						>
							<v-row
								no-gutters
								class="align-baseline"
							>
								<v-col cols="2">
									<v-icon
										small
										color="blue darken-2"
									>
										mdi-train
									</v-icon>
								</v-col>
								<v-col cols="10">
									<h6>{{ route && route.TRANSIT ? route.TRANSIT.routes[0].legs[0].distance.text : '?' }}</h6>
								</v-col>
								<v-col cols="2">
									<v-icon
										small
										color="blue lighten-2"
									>
										mdi-clock
									</v-icon>
								</v-col>
								<v-col
									cols="10"
									class="mt-0"
								>
									<h6
										indigo--text
										darken-4
									>
										{{ route && route.TRANSIT ? route.TRANSIT.routes[0].legs[0].duration.text : '?' }}
									</h6>
								</v-col>
							</v-row>
						</v-card>
					</v-col>

					<v-col
						cols="6"
						class="px-1"
					>
						<v-card
							:outlined="isDrivingSelected"
							:color="isDrivingSelected ? 'grey lighten-2' : undefined"
							class="pa-1 text-right"
							@click="goBy('DRIVING')"
						>
							<v-row
								no-gutters
								class="align-baseline"
							>
								<v-col cols="2">
									<v-icon
										small
										color="blue darken-2"
									>
										mdi-car
									</v-icon>
								</v-col>
								<v-col cols="10">
									<h6>{{ route && route.DRIVING ? route.DRIVING.routes[0].legs[0].distance.text : '?' }}</h6>
								</v-col>
								<v-col cols="2">
									<v-icon
										small
										color="blue lighten-2"
									>
										mdi-clock
									</v-icon>
								</v-col>
								<v-col
									cols="10"
								>
									<h6
										indigo--text
										darken-4
									>
										{{ route && route.DRIVING ? route.DRIVING.routes[0].legs[0].duration.text : '?' }}
									</h6>
								</v-col>
							</v-row>
						</v-card>
					</v-col>
				</v-row>
			</v-col>
			<v-col
				cols="1"
			>
				<v-btn
					icon
					small
					@click="removeRoute"
				>
					<v-icon small>
						mdi-close-circle-outline
					</v-icon>
				</v-btn>
			</v-col>
		</v-row>
	</section>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	props: {
		direction: {
			type: Object,
			default: () => ({})
		},
		origin: {
			type: Object,
			default: () => ({})
		},
		setRoute: {
			type: Function,
			default: () => {}
		},
		modeSelected: {
			type: String,
			default: 'TRANSIT'
		},
		placeSelected: {
			type: String,
			default: null
		}
	},
	
	data() {
		return {
			// route: null
		}
	},

	computed: {
		route () {
			for (let route of this.direction.origin) {
				if (route && route.origin && this.origin) {
					let lat1 = (typeof route.origin.lat === 'number' ? route.origin.lat : route.origin.lat())
					let lat2 = (typeof this.origin.lat === 'number' ? this.origin.lat : this.origin.lat())
					let lng1 = (typeof route.origin.lng === 'number' ? route.origin.lng : route.origin.lng())
					let lng2 = (typeof this.origin.lng === 'number' ? this.origin.lng : this.origin.lng())
					if (lat1 === lat2 && lng1 === lng2) {
						return route.route
					}
				}
			}
			return null
		},

		isTransitSelected () {
			return this.direction.destination.place_id === this.placeSelected && 'TRANSIT' === this.modeSelected
		},
		isDrivingSelected () {
			return this.direction.destination.place_id === this.placeSelected && 'DRIVING' === this.modeSelected
		}
	},

	methods: {
		...mapActions({ removeDirection: 'map/removeDirection' }),

		removeRoute () {
			if (this.isTransitSelected || this.isDrivingSelected) {
				this.setRoute(null)
			}
			this.removeDirection(this.direction)
		},

		goBy (mode) {
			this.setRoute(this.route, this.direction.destination, mode)
		}
	}
}
</script>

<style lang="scss" scoped>
.travelBtn {
  button { height: 60px!important; padding: 0 3px!important; width: 100%; }
}
</style>
